import React, { useRef, useState } from 'react';
import classNames from 'classnames/bind';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './PrefixSelect.module.scss';

export interface ICountryPrefix {
  Disabled: boolean;
  Group: any; // TODO: Check type
  Selected: boolean;
  Text: string;
  Value: string;
}

type Props = {
  name?: string;
  value?: string;
  prefixes: ICountryPrefix[];
  className?: string;
  isBolded?: boolean;
  onChange: (prefix: string) => void;
  disabled?: boolean;
};

const PrefixSelect = ({
  name,
  prefixes,
  value,
  className,
  isBolded,
  onChange,
  disabled,
}: Props) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const selectRef: any = useRef();

  const handleClick = () => {
    setShowOptions(!showOptions);
  }

  const handleChange = (prefix: string) => {
    setShowOptions(false);
    onChange(prefix);
  };

  return (
    <div className={classNames(styles.wrapper, className)}>
      <select
        ref={selectRef}
        name={name || 'prefix'}
        onClick={handleClick}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChange(e.target.value)}
        className={classNames(styles.toggleBtn, isBolded && styles.bolded)}
      >
        {(prefixes || []).map((item: ICountryPrefix) => (
          <option
            key={item.Value}
            value={item.Value}
            selected={item.Value === value || item.Selected}
            onChange={() => handleChange(item.Value)}
          >
            {item.Text}
          </option>
        ))}
      </select>
      {!disabled &&
        <Icon
          type={SvgIcons.CHEVRON_ICON}
          width={7}
          className={classNames(styles.icon, showOptions && styles.expanded)}
        />
      }
    </div>
  );
};

export default PrefixSelect;
